export const GOOGLE_CLIENT_ID =
  "678926924517-kiuet5gjf36c2nehfun87q9kb7mg1f4u.apps.googleusercontent.com";

export const FACEBOOK_APP_ID = "1060790898164238";
